import { Component, OnInit } from '@angular/core';
import { EditForm } from '../../../../base/controlers/edit-form';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { FormGroup, FormControl } from '@angular/forms';
import { IFileStoreItem } from '../../../../documents/interfaces/IFileStoreItem';
import { DoorType } from '../../models/door-type';
import { DoorTypeService } from '../../services/door-type.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-door-type-edit',
  templateUrl: './door-type-edit.component.html',
  styleUrls: ['./door-type-edit.component.css']
})
export class DoorTypeEditComponent extends EditForm<DoorType> implements OnInit {

  constructor(
    ns: ToastrService,          
    tr:TranslateService,
    r: Router,
    ds:DoorTypeService,
    ar: ActivatedRoute,
    l:Location,        
  ) { 
    super(ns,tr,r,ds,ar,l,'/plasard-measurement/door-type');
  }

  ngOnInit() {
    this.form = new FormGroup({
      id: new FormControl(),
      code: new FormControl(),
      name: new FormControl(),
      picture: new FormControl(),
      factor1: new FormControl(0),
      factor2: new FormControl(0),
      factor3: new FormControl(0),
      factor4: new FormControl(0),
      factor5: new FormControl(0)
    });
    super.ngOnInit();    
  }
  onFileUpload(file:IFileStoreItem){
    if(file){
      this.form.controls['picture'].setValue(file.id);
    }
    else {
      this.form.controls['picture'].setValue(null);
    }
  }

}
